var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15319_31049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 23C9 14.1634 16.1634 7 25 7C33.8366 7 41 14.1634 41 23C41 31.8366 33.8366 39 25 39C16.1634 39 9 31.8366 9 23Z",
    fill: "#0085E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 23C9 14.1634 16.1634 7 25 7C33.8366 7 41 14.1634 41 23C41 31.8366 33.8366 39 25 39C16.1634 39 9 31.8366 9 23Z",
    stroke: "#B5E7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4531 21.043C29.4531 18.5845 27.4585 16.5898 25 16.5898C22.5415 16.5898 20.5469 18.5845 20.5469 21.043C20.5469 21.4264 20.686 22.0202 21.02 22.8118C21.3447 23.5788 21.8055 24.4261 22.3343 25.2827C23.2157 26.7114 24.2362 28.0907 25 29.0741C25.7669 28.0907 26.7874 26.7114 27.6657 25.2827C28.1945 24.4261 28.6553 23.5788 28.98 22.8118C29.314 22.0202 29.4531 21.4264 29.4531 21.043ZM30.9375 21.043C30.9375 23.7458 27.3193 28.5576 25.7329 30.543C25.3525 31.0161 24.6475 31.0161 24.2671 30.543C22.6807 28.5576 19.0625 23.7458 19.0625 21.043C19.0625 17.765 21.722 15.1055 25 15.1055C28.278 15.1055 30.9375 17.765 30.9375 21.043ZM25.9896 21.043C25.9896 20.7805 25.8853 20.5288 25.6997 20.3432C25.5142 20.1576 25.2625 20.0534 25 20.0534C24.7375 20.0534 24.4858 20.1576 24.3003 20.3432C24.1147 20.5288 24.0104 20.7805 24.0104 21.043C24.0104 21.3054 24.1147 21.5571 24.3003 21.7427C24.4858 21.9283 24.7375 22.0326 25 22.0326C25.2625 22.0326 25.5142 21.9283 25.6997 21.7427C25.8853 21.5571 25.9896 21.3054 25.9896 21.043ZM22.526 21.043C22.526 20.3868 22.7867 19.7576 23.2506 19.2936C23.7146 18.8297 24.3439 18.569 25 18.569C25.6561 18.569 26.2854 18.8297 26.7494 19.2936C27.2133 19.7576 27.474 20.3868 27.474 21.043C27.474 21.6991 27.2133 22.3284 26.7494 22.7923C26.2854 23.2563 25.6561 23.5169 25 23.5169C24.3439 23.5169 23.7146 23.2563 23.2506 22.7923C22.7867 22.3284 22.526 21.6991 22.526 21.043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15319_31049",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.0470588 0 0 0 0 0.133333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15319_31049"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15319_31049",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryDestination);
export default __webpack_public_path__ + "static/media/delivery-destination.31da4bc1.svg";
export { ForwardRef as ReactComponent };